import '../../components/NewDocumentation/editorStyles.css';

import React, { useCallback, useEffect, useState } from 'react';
import { Color } from '@tiptap/extension-color';
import ListItem from '@tiptap/extension-list-item';
import TextStyle from '@tiptap/extension-text-style';
import { EditorContent, useEditor } from '@tiptap/react';
import Dropcursor from '@tiptap/extension-dropcursor';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import { Fab, Grid } from '@mui/material';
import Image from '@tiptap/extension-image';
import { useParams } from 'react-router-dom';
import FontFamily from '@tiptap/extension-font-family';
import Link from '@tiptap/extension-link';

import { TableExtension } from '../../components/NewDocumentation/Table';
import TableCell from '../../components/NewDocumentation/TableCellCust';
import TableHeader from '../../components/NewDocumentation/TableHeaderWIthStyles';
import TableRow from '../../components/NewDocumentation/TableRowCust';
import { Katex } from '../../components/NewDocumentation/Katex';
import { FontSize } from '../../components/NewDocumentation/FontSize';
import useNewDocumentation from '../../Hooks/NewDocumentation/useNewDocumentation';

function FullScreenReadOnlyEditor() {
  const { id } = useParams();
  const [content, setContent] = useState('');
  const { fetchDocumentDetails } = useNewDocumentation();
  const extensions = [
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    TextStyle.configure({ types: [ListItem.name] }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    StarterKit.configure({
      bulletList: {
        keepMarks: true,
        keepAttributes: false,
      },
      orderedList: {
        keepMarks: true,
        keepAttributes: false,
      },
    }),
    TableExtension.configure({
      resizable: true,
    }),
    TableRow,
    TableHeader,
    TableCell,
    Image.configure({ inline: true, allowBase64: true }),
    Dropcursor,
    Underline,
    Katex,
    FontSize,
    FontFamily,
    Link.configure({
      openOnClick: false,
    }),
  ];

  useEffect(() => {
    if (id) {
      fetchDocumentDetails(id).then((res) => {
        setContent(res?.data);
      });
    }
  }, [id]);

  const editorNew = useEditor({
    extensions,
    content,
  });

  useEffect(() => {
    if (editorNew) {
      editorNew.commands.setContent(content);
      editorNew.setEditable(false);
    }
  }, [editorNew, content]);

  const handlePrintClick = useCallback(() => {
    window.print();
  }, []);

  return (
    <Grid
      container
      xs={12}
      sx={{
        height: '100%',
        backgroundColor: (theme) => theme.palette?.other?.white,
        border: (theme) =>
          `1px solid ${theme.palette?.other?.editorBorderColor}`,
        '@media print': {
          backgroundColor: (theme) =>
            `${theme.palette?.other?.white} !important`,
          overflow: 'visible',
          height: 'auto',
          border: 'none',
        },
      }}
      p={2}
      display="flex"
      overflow="scroll"
    >
      <div
        aria-live="polite"
        role="alert"
        style={{
          width: '0px',
          height: '0px',
          overflow: 'hidden',
        }}
      >
        The content in editor is read only.
      </div>
      <Grid
        item
        height="100vh"
        width="100vw"
        sx={{
          backgroundColor: (theme) => theme.palette?.other?.white,
          '@media print': {
            height: '100%',
            backgroundColor: (theme) =>
              `${theme.palette?.other?.white} !important`,
          },
        }}
      >
        <EditorContent editor={editorNew} />
      </Grid>
      <Fab
        variant="extended"
        size="small"
        disableRipple={true}
        disableFocusRipple={true}
        sx={{
          padding: 2,
          position: 'fixed',
          bottom: '30px',
          right: ' 30px',
          zIndex: 1000,
          '@media print': {
            display: 'none',
          },
        }}
        color="primary"
        onClick={handlePrintClick}
      >
        Print
      </Fab>
    </Grid>
  );
}

export default FullScreenReadOnlyEditor;
